import { useTranslation } from 'react-i18next';

export const PatientInfoPopover = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-background-surface-primary typography-paragraph-4 text-text-secondary p-4 max-w-[220px] rounded-xl shadow-high">
      {t('organization.devices.description.patient')}
    </div>
  );
};
